/**
 * Service layer per gli indirizzi Reply-To verificati di un'entità (§11.1).
 * Solo gli indirizzi `verified` sono selezionabili come Reply-To in composizione.
 * L'aggiunta di un nuovo indirizzo passa per la verifica OTP a 2 step.
 *
 * Riferimento: TDD Sprint 18 §4.2 / §8.7.
 */
import API from '../../api';

export const replyToApi = {
  /** GET /entities/{entityId}/newsletter-emails — lista indirizzi (verificati e non). */
  list: (entityId) => API.get(`/entities/${entityId}/newsletter-emails`),

  /**
   * POST .../request-otp — invia un OTP all'indirizzo (NON salva ancora).
   * payload: { email, label?, is_default? }
   */
  requestOtp: (entityId, payload) => API.post(`/entities/${entityId}/newsletter-emails/request-otp`, payload),

  /**
   * POST .../confirm — verifica l'OTP e salva l'indirizzo (verified).
   * payload: { email, otp }
   */
  confirm: (entityId, payload) => API.post(`/entities/${entityId}/newsletter-emails/confirm`, payload),

  /** PUT .../{id} — aggiorna label / is_default. */
  update: (entityId, id, payload) => API.put(`/entities/${entityId}/newsletter-emails/${id}`, payload),

  /** DELETE .../{id} — rimuove l'indirizzo. */
  remove: (entityId, id) => API.delete(`/entities/${entityId}/newsletter-emails/${id}`),
};

export default replyToApi;